/**
 * Onboarding Page Content Configuration
 * Data extracted from Figma design specifications
 */

import { OnboardingPage } from './types';

// Pages 1-5: Onboarding carousel content - optimized WebP images
export const ONBOARDING_PAGES: OnboardingPage[] = [
  {
    id: 1,
    title: "Welcome to 'hey SriLanka'",
    description: 'Discover, plan, and explore Sri Lanka with ease',
    images: {
      mobile: [
        '/images/onboarding/welcome-mobile@1x.webp',
        '/images/onboarding/welcome-hero@1x.webp'
      ],
      desktop: [
        '/images/onboarding/welcome-desktop@1x.webp',
        '/images/onboarding/welcome-desktop-hero@1x.webp'
      ]
    },
    buttonText: 'Next'
  },
  {
    id: 2,
    title: 'Chat with AI',
    description: 'Our AI is trained exclusively on what Sri Lanka has to offer',
    images: {
      mobile: [
        '/images/onboarding/chat-mobile-scene@1x.webp',
        '/images/onboarding/chat-icon-large-new.mobile@1x.webp',
        '/images/onboarding/chat-icon-small-new@1x.webp'
      ],
      desktop: [
        '/images/onboarding/chat-desktop-scene@1x.webp',
        '/images/onboarding/chat-icon-large-new.desktop@1x.webp',
        '/images/onboarding/chat-desktop-scene@1x.webp'
      ]
    },
    buttonText: 'Next'
  },
  {
    id: 3,
    title: 'Explore Places',
    description: 'Find most rated and off the beaten path attractions, experiences, food and hotels',
    images: {
      mobile: [
        '/images/onboarding/explore-mobile-temple@1x.webp',
        '/images/onboarding/explore-mobile-search@1x.webp'
      ],
      desktop: [
        '/images/onboarding/explore-desktop-temple@1x.webp',
        '/images/onboarding/explore-desktop-search@1x.webp'
      ]
    },
    buttonText: 'Next'
  },
  {
    id: 4,
    title: 'Build Custom Itineraries',
    description: 'Plan your perfect trip, optimize routes and get quotes',
    images: {
      mobile: [
        '/images/onboarding/itinerary-mobile-ruins@1x.webp',
        '/images/onboarding/itinerary-mobile-route@1x.webp'
      ],
      desktop: [
        '/images/onboarding/itinerary-desktop-ruins@1x.webp',
        '/images/onboarding/itinerary-desktop-route@1x.webp'
      ]
    },
    buttonText: 'Next'
  },
  {
    id: 5,
    title: 'Validate Taxi Fares',
    description: 'Know cost estimates before you travel. Be informed!',
    images: {
      mobile: [
        '/images/onboarding/taxi-mobile-fishermen@1x.webp',
        '/images/onboarding/taxi-mobile-tuktuk@1x.webp'
      ],
      desktop: [
        '/images/onboarding/taxi-desktop-fishermen@1x.webp',
        '/images/onboarding/taxi-desktop-tuktuk@1x.webp'
      ]
    },
    buttonText: 'Next'
  }
];

// Page 6: Landing page content (not part of carousel) - optimized WebP images
export const LANDING_PAGE_DATA: OnboardingPage = {
  id: 6,
  title: "Welcome 'Ayubowan'",
  description: 'Start exploring Sri Lanka, your way',
  images: {
    mobile: [
      '/images/onboarding/allset-mobile-1@1x.webp'
    ],
    desktop: [
      '/images/onboarding/allset-desktop-1@1x.webp',
      '/images/onboarding/allset-desktop-3@1x.webp'
    ]
  },
  buttonText: 'Get Started',
  secondaryButtonText: 'Log In'
};

/**
 * Design Tokens - Extracted from Figma
 */
export const DESIGN_TOKENS = {
  colors: {
    primary: '#14b8a6',
    textDark: '#1a1a1a',
    textGray: '#6b7280',
    backgroundLight: '#fafafa',
    border: '#e5e7eb',
    white: '#ffffff'
  },
  typography: {
    mobile: {
      heading: {
        fontSize: '28px',
        lineHeight: '33.6px',
        letterSpacing: '-0.56px',
        fontWeight: '700'
      },
      body: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: '400'
      }
    },
    desktop: {
      heading: {
        fontSize: '40px',
        lineHeight: '33.6px',
        letterSpacing: '-0.56px',
        fontWeight: '700'
      },
      body: {
        fontSize: '24px',
        lineHeight: '30px',
        fontWeight: '400'
      }
    },
    button: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '600'
    },
    skip: {
      fontSize: '15px',
      lineHeight: '22.5px',
      fontWeight: '500'
    }
  },
  spacing: {
    mobileContentPadding: '32px',
    buttonHeight: '52px',
    skipButtonHeight: '36px',
    skipButtonWidth: '80px',
    dotSize: '8px',
    dotGap: '8px'
  },
  borderRadius: {
    button: '12px',
    skipButton: '8px',
    dot: '9999px'
  },
  shadows: {
    button: '0px 4px 12px 0px rgba(20, 184, 166, 0.25)'
  }
};

export const LOCAL_STORAGE_KEY = 'heysrilanka_onboarding_seen';

